//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:{
        searchData:Object
    },
    methods:{
        reset(){
            for(let key in this.searchData){
                this.searchData[key]=''
            }
            this.$emit('search')
        },
        search(){
            this.$emit('search')
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/search/Search.vue